import { render, staticRenderFns } from "./FloorAreaEntreprise.vue?vue&type=template&id=72b67b4e&"
import script from "./FloorAreaEntreprise.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaEntreprise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports